module.exports = __webpack_public_path__ + "media/not12.462ad5cd.mp3";